import { GCashButton } from '@src/components/GCashButton';
import { LottieSpinner } from '@src/components/LottieSpinner';
import { useWLOrderFormSelector } from '@talos/kyoko';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { useCancelBalanceTransaction } from './useCancelBalanceTransaction';
export function CashierOverlay() {
  const cancelBalanceTransaction = useCancelBalanceTransaction();
  const requestStep = useWLOrderFormSelector(state => state.swap.requestStep);
  const takingLongerThanExpected = useWLOrderFormSelector(state => state.swap.meta.takingLongerThanExpected);

  const navigate = useNavigate();

  const allowExitCashier = requestStep === 'waiting-for-confirmation' && takingLongerThanExpected;

  return (
    <motion.div
      key="cashier-view"
      data-testid="swap-spinner"
      className="fixed inset-0 z-[1000] grid place-items-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="bg-black-100 fixed inset-0 z-0 grid place-items-center opacity-50" />
      <div className="z-10 grid w-full place-items-center">
        <h1 className="text-color-text-inverse mb-4">
          {requestStep === 'opening-cashier'
            ? 'Opening Cashier...'
            : requestStep === 'waiting-for-confirmation'
              ? takingLongerThanExpected
                ? 'Taking longer than expected...'
                : 'Waiting for confirmation...'
              : 'Loading...'}
        </h1>
        <LottieSpinner />

        {requestStep === 'opening-cashier' && (
          <GCashButton
            size="md"
            variant="primary"
            className="mt-4"
            onClick={cancelBalanceTransaction}
            data-testid="cancel-button"
          >
            Cancel
          </GCashButton>
        )}

        {allowExitCashier && (
          <GCashButton
            size="md"
            variant="primary"
            className="mt-4"
            onClick={() => {
              navigate('/transactions');
            }}
            data-testid="exit-cashier-button"
          >
            Go back
          </GCashButton>
        )}
      </div>
    </motion.div>
  );
}
